module.exports = __webpack_public_path__ + "static/media/photo-camera.5e8c2544.svg";